<template>
  <div id="orders">
    <div align="right" class="lv3Text r1">
      <router-link to="/user/recycle">
        <i class="el-icon-delete"></i>订单回收站
      </router-link>
    </div>
    <el-tabs type="border-card" @tab-click="tabFn">
      <el-tab-pane label="全部订单"></el-tab-pane>
      <el-tab-pane :label="counts[0] > 0?'待付款('+counts[0]+')':'待付款'"></el-tab-pane>
      <el-tab-pane :label="counts[1] > 0?'待发货('+counts[1]+')':'待发货'"></el-tab-pane>
      <el-tab-pane :label="counts[2] > 0?'待收货('+counts[2]+')':'待收货'"></el-tab-pane>
      <el-tab-pane :label="counts[3] > 0?'待评价('+counts[3]+')':'待评价'"></el-tab-pane>
    </el-tabs>
    <div v-if="loading2" style="padding:50px 0;">
      <square-loader color="#e2211c"></square-loader>
    </div>
    <div class="table" v-if="empty==false">
      <div v-for="(item,index) of data" :key="index" class="od-item">
        <div class="od-title">
          <span class="tx1">{{item.date}}</span>
          <span class="tx2">订单编号：{{item.orderCode}}</span>
          <span v-if="item.address" class="tx2" style="margin-left:30px">收货人 ：{{item.address}}</span>
        </div>
        <div class="content">
          <div v-for="(item2,index2) of productArr[index]" :key="index2">
            <el-row v-if="index2<3">
              <el-col :span="3">
                <div>
                  <el-image
                    style="width: 100px; height: 100px;padding:10px;"
                    :src="serve+item2.images"
                    fit="cover"
                  ></el-image>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="i1 lv2Text">{{item2.title.substr(0,20)}}</div>
                <div class="i2 lv3Text">货号：{{item2.item_no}}</div>
              </el-col>
              <el-col :span="3">
                <div class="i2" style="line-height:110px">数量：x{{item2.number}}</div>
              </el-col>
              <el-col :span="3">
                <div style="padding-top:30px;">
                  <div class="i3" style="line-height:20px">{{item.statusTxt}}</div>
                  <div
                    class="i3"
                    v-if="item.status==1 || item.status== 0"
                    style="margin-top:10px;cursor: pointer;"
                    @click="clear_order()"
                  >取消订单</div>
                  <div v-if="item.status==3">
                    <el-link @click="viewLog(item.orderCode)">查看物流</el-link>
                  </div>
                </div>
              </el-col>
              <el-col :span="3" v-if="index2 == 0">
                <div style="height: 70px;padding-top: 15px;" class="od-menu-div">
                  <div class="od-menu" v-if="item.status==4">
                    <router-link :to="'/user/comment?id='+item.id" class="lv2Text">去评价</router-link>
                  </div>
                  <div class="od-menu">
                    <router-link :to="'/user/viewOrder/1?id='+item.id" class="lv2Text">查看详情</router-link>
                   
                  </div>
                  <div class="od-menu" @click="canCancelOrder(item.id)" v-if="item.status==0">取消订单</div>
                  <div class="od-menu lv2Text" @click="delOrder(item.id)" v-if="item.status>=6">删除订单</div>
                  <div
                    class="od-menu lv2Text"
                    @click="save(item.orderCode)"
                    v-if="item.status==5&&item.change_inventory==0"
                  >转为库存</div>
                </div>
              </el-col>
            </el-row>
            <div v-if="index2==3" class="more lv3Text">
              <router-link :to="'/user/viewOrder/1?id='+item.id" class="lv2Text">
                更多
                <i class="el-icon-d-arrow-right"></i>
              </router-link>
            </div>
          </div>
        </div>
        <div class="bottom lv3Text" style="font-size:12px">
          <el-row>
            <el-col :span="15">
              <div style="padding-top:10px">
                <span>
                  商品件数：
                  <span class="red">{{item.count}} 件</span>
                </span>
                <span>
                  商品总价：
                  <span class="red">&yen; {{item.all_money}}</span>
                </span>
                <span>
                  活动优惠：
                  <span class="red">- &yen; 0</span>
                </span>
                <span>
                  运费：
                  <span class="red">&yen; {{item.express_money}}</span>
                </span>
              </div>
            </el-col>
            <el-col :span="9" align="right">
              <span class="od-price">
                应付总额：
                <span>&yen;{{item.pay_money}}</span>
              </span>
              <span v-if="item.status==0">
                <el-button size="medium" @click="goPay(item.orderCode)">去付款</el-button>
              </span>
              <span v-if="item.status==3">
                <el-button size="medium" @click="finish(item.orderCode)">确认收货</el-button>
              </span>
            </el-col>
          </el-row>
        </div>
      </div>
      <div v-if="data.length == 0" class="order_null">
        <img style="margin:0 auto" :src="serve+ '/image/none/order.jpg'" alt />
      </div>
    </div>
    <div v-if="empty==true" class="empty" style="padding-bottom:30px;">
      <div style="padding:30px 0">
        <object
          :data="serve+'/images/analyze_report_2.svg'"
          type="image/svg+xml"
          style="width:15%;"
        ></object>
      </div>
      <div style="margin: 10px 0 20px 0;">没有订单</div>
    </div>
    <div v-if="total>0" style="padding: 20px;" align="center">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        @current-change="changePage"
        hide-on-single-page
      ></el-pagination>
    </div>
    <el-dialog title="取消订单" :visible.sync="delOrderDialog" width="50%">
      <div>取消订单后，本单享有的优惠可能会一并取消，是否继续？</div>
      <div class="lv3Text" style="font-size:12px;margin-top: 10px;">请选择取消订单的原因（必选）：</div>
      <div class="reason">
        <el-row :gutter="20">
          <el-col :span="12">
            <button @click="delReason=1" :class="delReason==1?'active':''">配送信息有误</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=2" :class="delReason==2?'active':''">商品买错了</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=3" :class="delReason==3?'active':''">重复下单/误下单</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=4" :class="delReason==4?'active':''">忘记使用优惠券/积分等</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=5" :class="delReason==5?'active':''">其他渠道价格更低</button>
          </el-col>
          <el-col :span="12">
            <button @click="delReason=6" :class="delReason==6?'active':''">不想买了</button>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delOrderDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="cancelOrder()"
          :loading="loading1"
          :disabled="delReason==null"
        >确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="选择项目" :visible.sync="saveDialog" width="500px">
      <div>
        <span>选择项目：</span>
        <el-select v-model="save1" placeholder="请选择">
          <el-option v-for="(item,index) in nameList" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </div>
      <div style="margin-top:20px">
        <span>选择资金：</span>
        <el-select v-model="save2" placeholder="请选择">
          <el-option v-for="(item,index) in classArr" :key="index" :label="item" :value="item"></el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveDialog = false">取 消</el-button>
        <el-button type="primary" @click="submit2" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="物流信息" :visible.sync="logDialog" width="600px">
      <div style="height:200px;overflow:auto;padding-top:20px">
        <el-timeline :reverse="true">
          <el-timeline-item
            v-for="(activity, index) in log"
            :key="index"
            :color="activity.color"
            :timestamp="activity.datetime"
          >{{activity.remark}}</el-timeline-item>
        </el-timeline>
      </div>
    </el-dialog>
    <!-- 取消订单弹框 -->

    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <span>取消订单请联系客服，若订单已进入采购部流程则无法取消。</span>
      <br />
      <span style="line-height:40px">客服电话 : 133 1168 8691</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="温馨提示" center :visible.sync="dialogVisible10" width="30%">
      <div style="text-align:center">商品库存不足，订单为预购订单，是否继续？</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible10 = false">取 消</el-button>
        <el-button type="primary" @click="goPay1">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import SquareLoader from "vue-spinner/src/SquareLoader.vue";

export default {
  components: {
    SquareLoader
  },
  data() {
    return {
      dialogVisible10: false,
      numOrder: null,
      serve: this.$store.state.serve,
      dialogVisible: false,
      //
      classArr: [],
      save1: null,
      save2: null,
      log: {},
      logDialog: false,
      empty: null,
      loading2: true,
      data: null,
      productArr: [],
      tabParam: null,
      page: 1,
      total: 0,
      counts: [],
      delOrderDialog: false,
      delReason: null,
      loading1: false,
      delId: null,
      fullscreenLoading: false,
      saveDialog: false,
      projects: {},
      project: "",
      orderCode: "",
      loading: false,
      nameList: null
    };
  },
  activated() {
    this.$store.state.user_location = "我的订单";
    this.tabDataFn();
  },
  created() {
    this.$store.state.user_location = this.$route.params.path;
    this.tabDataFn();
    this.axios
      .get(this.serve + "/personal/host_name_list", {
        params: {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token")
        }
      })
      .then(res => {
        if (res.data.data) {
          this.nameList = res.data.data;
        }
      });
    this.axios
      .get(this.serve + "/personal/project_class", {
        params: {
          mobile: this.$cookies.get("user"),
          token: this.$cookies.get("token")
        }
      })
      .then(res => {
        for (var item of res.data) {
          for (var item2 of item.children) {
            this.classArr.push(item2);
          }
        }
      });
  },
  methods: {
    clear_order() {
      this.dialogVisible = true;
    },
    //
    viewLog(num) {
      this.logDialog = true;
      this.log = {};
      this.axios
        .get(this.serve + "/personal/express_select", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            orderCode: num
          }
        })
        .then(res => {
          if (res.data) {
            this.log = _.reverse(res.data);
            this.log[0].color = "#27C194";
          }
        });
    },
    submit2() {
      this.loading = true;
      this.axios
        .get(this.serve + "/personal/order_change_inventory", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            orderCode: this.orderCode,
            project: this.save1,
            class: this.save2
          }
        })
        .then(res => {
          this.loading = false;
          if (res.data.status == "success") {
            this.$message("已转为库存");
            this.tabDataFn();
            this.saveDialog = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    save(id) {
      this.saveDialog = true;
      this.orderCode = id;
      this.axios
        .get(this.serve + "/personal/my_project_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.projects = res.data.data;
        });
    },
    finish(order) {
      this.axios
        .get(this.serve + "/personal/sign_order", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            orderCode: order
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.$message("已收货");
            this.tabDataFn();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    goPay(number) {
      this.numOrder = number;
      this.axios
        .get(this.serve + "/personal/orderIsAdvance", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            orderCode: number
          }
        })
        .then(res => {
          if (res.data.data == 1) {
            this.dialogVisible10 = true;
          } else {
            this.$router.push("/user/pay?order=" + number);
          }
        });
    },
    goPay1() {
       this.dialogVisible10 = false;
      this.$router.push("/user/pay?order=" + this.numOrder);
    },
    delOrder(id) {
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
      this.axios
        .get(this.serve + "/personal/del_order", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            order_id: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            loading.close();
            this.$message("订单已删除");
            this.tabDataFn();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    canCancelOrder(id) {
      this.delOrderDialog = true;
      this.delId = id;
    },
    cancelOrder() {
      this.loading1 = true;
      this.axios
        .get(this.serve + "/personal/cancel_order", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            order_id: this.delId,
            cause: this.delReason
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            this.loading1 = false;
            this.delOrderDialog = false;
            this.$message("订单已取消");
            this.tabDataFn();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    handleClose() {
      this.delReason = null;
    },
    changePage(p) {
      this.page = p;
      this.tabDataFn();
    },
    tabDataFn() {
      this.productArr = [];
      this.loading2 = true;
      this.empty = null;
      this.axios
        .get(this.serve + "/personal/order_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            status: this.tabParam,
            page: this.page
          }
        })
        .then(res => {
          this.loading2 = false;
          if (res.data.msg == "搜索结果为空") {
            this.data = null;
            this.total = 0;
            this.empty = true;
          } else {
            this.empty = false;
            this.data = res.data.data.results;
            this.total = res.data.data.total;
            this.counts = res.data.data.counts;
            for (var item of this.data) {
              var l = this.productArr.length;
              var listObj = JSON.parse(item["product_list"]);
              this.productArr[l] = listObj;
              var res = this.dayjs
                .unix(item["create_time"])
                .format("YYYY-MM-DD HH:mm:ss");
              item["date"] = res;
              var totalNumber = 0;
              if (listObj) {
                for (var item2 of listObj) {
                  totalNumber += parseFloat(item2.number);
                }
              }
              item["count"] = totalNumber;
              item["statusTxt"] = "";
              switch (item["status"]) {
                case "0":
                  item["statusTxt"] = "待付款";
                  break;
                case "1":
                  item["statusTxt"] = "待发货";
                  break;
                case "2":
                  item["statusTxt"] = "待发货";
                  break;
                case "3":
                  item["statusTxt"] = "待收货";
                  break;
                case "4":
                  item["statusTxt"] = "待评价";
                  break;
                case "5":
                  item["statusTxt"] = "已完成";
                  break;
                case "6":
                  item["statusTxt"] = "已取消";
                  break;
              }
            }
          }
        });
    },
    tabFn(v) {
      if (v.label.search("全部订单") == 0) {
        this.tabParam = null;
        this.tabDataFn();
      }
      if (v.label.search("待付款") == 0) {
        this.tabParam = 0;
        this.tabDataFn();
      }
      if (v.label.search("待发货") == 0) {
        this.tabParam = 1;
        this.tabDataFn();
      }
      if (v.label.search("待收货") == 0) {
        this.tabParam = 3;
        this.tabDataFn();
      }
      if (v.label.search("待评价") == 0) {
        this.tabParam = 4;
        this.tabDataFn();
      }
      if (v.label.search("回收站") == 0) {
        this.tabParam = null;
        this.tabDataFn();
      }
      this.page = 1;
    }
  }
};
</script>
<style lang="scss">
#orders {
  min-height: 600px;
  .order_null {
    text-align: center;
    font-size: 20px;
    padding: 30px 0;
    color: #999;
    // line-height: 40px;
  }
  .r1 {
    padding: 5px;
    margin-right: 10px;
    cursor: pointer;
    position: relative;
    top: 5px;
    margin-bottom: -26px;
    z-index: 10;
    display: inline-block;
    float: right;
  }
  .r1:hover {
    color: #606266;
  }
  .el-icon-delete .lv3Text {
    color: #909399;
  }
  .empty {
    color: #dcdfe6;
  }
  .table {
    margin-top: -15px;
  }
  .el-tabs--border-card {
    border: 0;
    -webkit-box-shadow: none;
    box-shadow: none;
  }
  .reason {
    padding: 20px 0;
  }
  .reason button {
    display: block;
    width: 100%;
    background-color: #fff;
    border: 1px solid #ddd;
    color: #666;
    line-height: 40px;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .reason button.active {
    border: 1px solid #e2211c;
    color: #e2211c;
  }
  .od-menu:hover {
    text-decoration: underline;
  }
  .od-menu {
    cursor: pointer;
  }
  .more {
    background-color: #f5f5f5;
    text-align: center;
    padding: 3px 0;
    font-size: 12px;
    border-bottom: 1px solid #ddd;
    cursor: pointer;
  }
  .more:hover {
    text-decoration: underline;
  }
  .viewAll {
    font-size: 12px;
    cursor: pointer;
  }
  .viewAll a {
    color: #909399;
  }
  .viewAll:hover {
    text-decoration: underline;
  }
  .red {
    color: #e2211c;
    margin-right: 10px;
  }
  .od-price span {
    color: #e2211c;
    font-weight: bold;
    font-size: 20px;
  }
  .od-price {
    margin-right: 20px;
  }
  .content .el-row {
    border-bottom: 1px solid #ddd;
  }
  .od-menu {
    line-height: 1.5em;
  }
  .i1 {
    padding-top: 30px;
    margin-bottom: 5px;
    color: #333;
  }
  .i2 {
    color: #666;
    font-size: 12px;
  }
  .i3 {
    color: #e2211c;
  }
  .title {
    background-color: #eeeeee;
    padding: 10px 20px;
  }
  background-color: #fff;
  .photo {
    border-radius: 50%;
  }
  .od-title {
    background-color: #f5faf9;
    padding: 15px;
    border-bottom: 1px solid #ddd;
    font-size: 12px;
    .tx1 {
      color: #666666;
      margin-right: 10px;
    }
    .tx2 {
      color: #333333;
    }
  }
  .od-item {
    margin: 10px;
    border: 1px solid #ddd;
    margin-bottom: 20px;
    .bottom {
      padding: 10px;
    }
  }

  .el-tabs--border-card > .el-tabs__header {
    background-color: #f9f9f9;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item {
    border-top: 3px solid transparent;
  }
  .el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
    border-top: 3px solid #e2211c;
  }
}
</style>